import React, { useState, useEffect } from 'react'
// IMAGES
import imageIconTelephone from '../../../images/iconTelephone.png'

const IdentificationAuth = ({ values, handleChange, _signIn, keyUid, _forgotPassword, _handleNavigate, tokenUser, clients , _signUp, _handleNavigatePageFilterUserServeur }) => {
    const [show, setShow] = useState('connecter')

    return (
        <div className='row'>
            {/* CARD MES RENDEZ-VOUS */}
            <div className='mb-3 border-bottom shadow'>
                <div className='card-body'>
                    <div className='card-title'>Vous n'avez pas encore pris de rdv.</div>
                    <button className='btn btn-dark rounded-pill' onClick={_handleNavigate}>Prendre RDV</button>
                </div>
            </div>

            {/* SE CONNECTER */}
            {show === 'connecter' && 
                <>
                    {/* INPUT */}
                    <div className='mt-2'>
                        <input type="email" className='form-control rounded-pill' value={values.email} name='email' onChange={handleChange} placeholder='Email' />
                    </div>
                    <div className='mt-2'>
                        <input type="password" className='form-control rounded-pill' value={values.password} name='password' onChange={handleChange} placeholder='Mot de passe' />
                    </div>
                    
                    {/* BUTTON CREER UN COMPTE */}
                    <button 
                        className='btn btn-dark mt-3 rounded-pill' 
                        type='button'
                        disabled={values.email && values.password ? false : true}
                        onClick={() => [_signIn(values.email, values.password, tokenUser, clients, keyUid) , _handleNavigatePageFilterUserServeur()]}
                    >Se connecter</button>

                    {/* FORGOT PASSWORD */}
                    <u className='mb-4 text-center mt-1' style={{ cursor:'pointer', fontSize:14 }} onClick={() => _forgotPassword(values.email)}>mot de passe oublié</u>
                    
                    {/* BUTTON CREER UN COMPTE */}
                    <div className='h3 text-center my-3'>ou</div>
                    <button 
                        className='btn btn-dark mt-3 rounded-pill' 
                        type='button'
                        disabled={values.email && values.password ? false : true}
                        onClick={() => setShow('creer')}
                    >Créer un compte</button>
                </>
            }
            
            {/* CREER UN COMPTE */}
            {show === 'creer' && 
                <>
                    {/* INPUT */}
                    <div className='mt-3'>
                    <input type="text" className='form-control border-0 rounded-pill shadow p-2' placeholder="Prénom" values={values.surname} name='surname' onChange={handleChange} />
                    </div>
                    <div className='mt-3'>
                        <input type="text" className='form-control border-0 rounded-pill shadow p-2' placeholder="Nom" values={values.name} name='name' onChange={handleChange} />
                    </div>
                    <div className='mt-3'>
                        <input type="email" className='form-control border-0 rounded-pill shadow p-2' placeholder="Email" values={values.email} name='email' onChange={handleChange} />
                    </div>
                    <div className='mt-3'>
                        <input type="password" className='form-control border-0 rounded-pill shadow p-2' placeholder="Mot de passe" values={values.password} name='password' onChange={handleChange} />
                    </div>

                    {/* INPUT PHONE */}
                    <div className='mt-3'>
                        <div className="input-group rounded-pill shadow">
                            <span 
                                className="bg-white border-0 rounded-pill" 
                                style={{ marginLeft:'1rem', paddingTop:'0.2rem'}}
                            >
                                <img 
                                    src={imageIconTelephone} 
                                    alt='image du logo' 
                                    style={{ height:20, width:20, marginTop:'0.2rem' }} 
                                />
                            </span>
                            <input type="text" className='form-control border-0' value={values.phone} name='phone' onChange={handleChange} placeholder='Téléphone' />
                            <span 
                                className="bg-white border-0 rounded-pill" 
                                style={{ marginRight:'1rem', paddingTop:'0.2rem', height:20, width:20 }}
                            >
                            </span> 
                        </div>
                    </div>

                    {/* BUTTON CREER UN COMPTE */}
                    <div className='text-center my-3'>
                        <button 
                            type='button'
                            className='btn btn-outline shadow rounded-pill' 
                            disabled={values.surname && values.name && values.email && values.password ? false : true}
                            // onClick={() => console.log('Modal Create Account ',values.surname, values.name, values.email, values.password, keyUid, tokenUser)}
                            
                            onClick={() => [_signUp(values.name, values.surname, values.email, values.password, keyUid, tokenUser, values.phone), _handleNavigatePageFilterUserServeur()]}
                        >Créer mon compte</button>  
                    </div>
                </>
            }

        </div>
    )
}

export default IdentificationAuth